import { FilterType, Filter, FilterKey } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '..';
import { orderBy } from 'lodash';

const key = FilterKey.NATIONALITY;
export const getNationalityFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  let nationalityFilterOptions = filterOptions?.nationality || [];
  if (!nationalityFilterOptions) {
    console.warn('Nationality filter options could not be extracted from filter options.');
    nationalityFilterOptions = [];
  }
  const options = nationalityFilterOptions.map(nationality => {
    return {
      ...nationality,
      checked: filters.some(filter => filter === nationality.value),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Nationality',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
